document.addEventListener('DOMContentLoaded', function () {
	
  // Mobile menu pusbary instance
  const pushbar = new Pushbar({
    blur: true,
    overlay: true
  });

  /*
   * Close pushbar mobile menu
   */
  function closeMobileMenu() {
    const closeButton = document.querySelector('.mobile-close img');

    if (closeButton) {
      closeButton.addEventListener('click', function() {
        pushbar.close();
      });
    }
  }
  
  /*
   * Add active class to mobile links on click
   */
  function mobileMenuLinks() {
    const links = document.querySelectorAll('.mobile .menu-item-has-children > a');

    links.forEach(link => {
      link.addEventListener('click', function(event) {
        event.preventDefault();
        
        const li = this.parentElement;
        if (!li) return;
        
        const isOpen = li.classList.contains('open');
        const willOpen = !isOpen;
        
        li.classList.toggle('open', willOpen);
        this.setAttribute('aria-expanded', String(willOpen));
        
        // Optional: Close other open menus (accordion behavior)
        if (willOpen) {
          const otherOpenItems = document.querySelectorAll('.mobile .menu-item-has-children.open');
          otherOpenItems.forEach(item => {
            if (item !== li) {
              item.classList.remove('open');
              const otherLink = item.querySelector('> a');
              if (otherLink) otherLink.setAttribute('aria-expanded', 'false');
            }
          });
        }
      });
    });
  }

  /*
   * Scroll button once clicked to scroll user to top of page
   */
  function scrollToTop() {
    const button = document.querySelector('.scroll-top button');

    if (button) {
      button.addEventListener('click', function() {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      });
    }
  }

  closeMobileMenu();
  mobileMenuLinks();
  scrollToTop();
});